import React from 'react';
import styles from './LoaderExt.module.scss';

function LoaderExt(props) {
    let classNameVariable = "";
    switch (props && props.customClass) {
        case "claimDetailsLoader":
            classNameVariable = styles.loaderCustomClaimDetailsCls
            break;
        case "CoveragesLoader":
            classNameVariable = styles.CoveragesLoader
            break;
        case "InlineLoader":
            classNameVariable = styles.InlineLoader
            break;
        case "microApp":
            classNameVariable = styles.microApp
            break;
        default:
            classNameVariable = styles.textAlign
            break;
    }
    return (
        <div className={classNameVariable}>
            <span className={styles.loader1}></span>
            <span className={styles.loader2}></span>
            <span className={styles.loader3}></span>
            <span className={styles.loader4}>{props.showLoadingText !== undefined && props.showLoadingText ? "Please wait for the available policies to load." : ''}</span>
        </div>
    );
}

export default LoaderExt;